__turbopack_context__.v({
  "bannerContainer": "MonthlyMatchingBanner-module__tlIPtW__bannerContainer",
  "gentleLink": "MonthlyMatchingBanner-module__tlIPtW__gentleLink",
  "learnMoreText": "MonthlyMatchingBanner-module__tlIPtW__learnMoreText",
});
